module.exports = __webpack_public_path__ + "static/message2-858c332189b16674702322699a2136b8.png";